/** 대시보드 목업용 라인 아이콘 스프라이트. <svg><use href="#i-home" /></svg> 로 참조 */
export default function IconSprite() {
  return (
    <svg width="0" height="0" style={{ position: 'absolute' }} aria-hidden="true">
      <defs>
        <symbol id="i-home" viewBox="0 0 24 24">
          <path d="M4 10.8 12 4l8 6.8V20a1 1 0 0 1-1 1h-4v-6H9v6H5a1 1 0 0 1-1-1z" />
        </symbol>
        <symbol id="i-chat" viewBox="0 0 24 24">
          <path d="M20 6.5A2.5 2.5 0 0 0 17.5 4h-11A2.5 2.5 0 0 0 4 6.5v6A2.5 2.5 0 0 0 6.5 15H8v4l4.5-4h5A2.5 2.5 0 0 0 20 12.5z" />
          <path d="M9 9.5h6" />
        </symbol>
        <symbol id="i-doc" viewBox="0 0 24 24">
          <path d="M14 3H7a1 1 0 0 0-1 1v16a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1V7z" />
          <path d="M14 3v4h4M9 12h6M9 16h4" />
        </symbol>
        <symbol id="i-upload" viewBox="0 0 24 24">
          <path d="M12 15V4m0 0 3.5 3.6M12 4 8.5 7.6" />
          <path d="M4.5 15v3.5a1.5 1.5 0 0 0 1.5 1.5h12a1.5 1.5 0 0 0 1.5-1.5V15" />
        </symbol>
        <symbol id="i-image" viewBox="0 0 24 24">
          <rect x="4" y="4.5" width="16" height="15" rx="2.5" />
          <circle cx="9" cy="10" r="1.6" />
          <path d="m5 17 4.5-4.5L13 16l3-2.5 3 3.5" />
        </symbol>
        <symbol id="i-gear" viewBox="0 0 24 24">
          <circle cx="12" cy="12" r="3.2" />
          <path d="M12 2.6v2.6M12 18.8v2.6M4.4 12H7M17 12h2.6M6.3 6.3l1.9 1.9M15.8 15.8l1.9 1.9M17.7 6.3l-1.9 1.9M8.2 15.8l-1.9 1.9" />
        </symbol>
        <symbol id="i-download" viewBox="0 0 24 24">
          <path d="M12 4v9m0 0 3.4-3.5M12 13 8.6 9.5" />
          <path d="M4.5 15.5v3a1.5 1.5 0 0 0 1.5 1.5h12a1.5 1.5 0 0 0 1.5-1.5v-3" />
        </symbol>
      </defs>
    </svg>
  )
}
